import { Select } from "@/components/ui/input";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import React from "react";

function ChildSelect({ childCount, tempValues, setTempValues }) {
  const t = useTranslationDetector();

  if (!childCount || childCount === 0) {
    return null;
  }

  const ages = Array.from({ length: 17 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1), // 1 - 11 yaş
  }));

  const handleChange = (index) => (e) => {
    const value = e.target.value;
    const prevAges = tempValues?.childrenAges || [];
    const next = Array.from({ length: Math.max(childCount, 0) }, (_, i) =>
      prevAges?.[i] !== undefined ? prevAges[i] : "",
    );
    next[index] = value;
    setTempValues((prev) => ({ ...prev, childrenAges: next }));
  };

  const selectedAges = tempValues?.childrenAges || [];

  return (
    <div className="flex flex-col gap-4 p-4 border-b border-primary-weak">
      <div className="flex flex-col gap-4">
        {Array.from({ length: childCount }).map((_, idx) => (
          <div key={idx} className="flex items-center justify-between">
            <label
              htmlFor={`childAge_${idx}`}
              className="text-foreground font-medium"
            >
              {`${idx + 1}. ${t("hotelSearch.childAgeLabel")}`}
            </label>
            <Select
              className="mt-0 w-[180px] md:w-[138px]"
              id={`childAge_${idx}`}
              options={ages}
              placeholder={t("hotelSearch.childAgeSelectPlaceholder")}
              value={selectedAges?.[idx] ?? ""}
              onChange={handleChange(idx)}
              showPlaceholder
            />
          </div>
        ))}
      </div>

      <div className="text-sm">
        {t("hotelSearch.childSelectBottomDescription")}
      </div>
    </div>
  );
}

export default ChildSelect;
